import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography, Stack } from '@mui/material';
import ExpandMore from '@mui/icons-material/ExpandMore';

const ComplianceAccordion = ({
	title,
	children,
	tasks,
	expandedByDefault,
	truncateTotal,
	accordionMode = true,
	...props
}) => {
	const sx = props?.sx ?? {};

	const [expanded, setExpanded] = useState(() => Boolean(expandedByDefault));

	const completed = useMemo(() => tasks.filter((t) => t?.completed).length, [tasks]);

	const Content = useCallback(
		() => (
			<Stack
				spacing={1}
				direction='row'
				justifyContent={'space-between'}
				alignItems={'center'}
				width={'100%'}
			>
				<Typography className='compliance-accordion-title' variant='subtitle2'>
					{title}
				</Typography>
				<Typography variant='task_updated'>{`${completed}/${tasks.length}${truncateTotal ? '' : ' complete'}`}</Typography>
			</Stack>
		),
		[title, tasks.length, truncateTotal],
	);

	return accordionMode ? (
		<Accordion
			elevation={0}
			disableGutters
			square
			expanded={expanded}
			onChange={() => setExpanded((prev) => !prev)}
			{...(props ?? {})}
			sx={{
				backgroundColor: 'transparent',
				width: '100%',
				'&:not(:last-child)': {
					borderBottom: 0,
				},
				'&::before': {
					display: 'none',
				},
				...sx,
			}}
		>
			<AccordionSummary
				expandIcon={<ExpandMore sx={(theme) => ({ color: theme.palette.primary.main })} />}
				sx={{
					borderBottom: 'none',
					padding: 0,
				}}
			>
				<Content />
			</AccordionSummary>
			<AccordionDetails sx={{ padding: '0px' }}>{children}</AccordionDetails>
		</Accordion>
	) : (
		<Stack {...(props ?? {})}>
			<Content />
			{children}
		</Stack>
	);
};

export default ComplianceAccordion;
